
import {
  GET_QUARANTINE_DOWNLOAD_FAILURE,
  GET_QUARANTINE_DOWNLOAD_REQUEST,
  GET_QUARANTINE_DOWNLOAD_SUCCESS,
  GET_QUARATINE_REPORT_FAILURE,
  GET_QUARATINE_REPORT_REQUEST,
  GET_QUARATINE_REPORT_SUCCESS,
} from "./quaratineReportTypes";


const initialStateForTransactionReport = {
  loading: false,
  trnReport: [],
  error: "",
};

const getQuarantineReportReducer = (
  state = initialStateForTransactionReport,
  action
) => {
  switch (action.type) {
    case GET_QUARATINE_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_QUARATINE_REPORT_SUCCESS:
      return {
        loading: false,
        trnReport: action.payload,
        error: "",
      };
    case GET_QUARATINE_REPORT_FAILURE:
      return {
        loading: false,
        trnReport: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDownloadGrnReport = {
  loading: false,
  consumptionReport: [],
  error: "",
};

const downloadQuarantineReportReducer = (
  state = initialStateForDownloadGrnReport,
  action
) => {
  switch (action.type) {
    case GET_QUARANTINE_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_QUARANTINE_DOWNLOAD_SUCCESS:
      return {
        loading: false,
        consumptionReport: action.payload,
        error: "",
      };
    case GET_QUARANTINE_DOWNLOAD_FAILURE:
      return {
        loading: false,
        consumptionReport: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getQuarantineReportReducer, downloadQuarantineReportReducer };
